module.exports = __webpack_public_path__ + "img/error2.fcf1e974.gif";